import Rate from 'rc-rate';
import styled from 'styled-components';
import { mq } from 'stylesheets/utils';
export const Section = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.innerProduct.lightGray};
  border-radius: 4px;
  padding: 26px 60px;
  margin-bottom: 40px;
  display: flex;
  justify-content: space-between;
  ${mq(1200)} {
    padding: 16px;
  }
  ${mq(992)} {
    /* align-items: flex-start; */
    flex-direction: column-reverse;
  }
`;
export const SectionTitle = styled.h5`
  font-weight: ${({ theme }) => theme.fontWeight.font500};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.h5};
  margin-bottom: 24px;
  text-transform: capitalize;
`;

export const ReviewsList = styled.div`
  max-width: 510px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${mq(992)} {
    max-width: 100%;
  }
`;

export const ReviewListHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export const ReviewsNumber = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  text-transform: capitalize;
`;

export const ShowMoreArrow = styled.div`
  max-width: 24px;
  min-width: 24px;
  max-height: 24px;
  min-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(-1, 1) /*rtl:none */;
`;

export const ShowMore = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.cartCountColor};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
`;

export const RatingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${mq(992)} {
    margin-bottom: 16px;
  }
`;

export const Number = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font600};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.h3};
`;

export const StyledRate = styled(Rate)`
  &.rc-rate {
    height: 16px;
    font-size: ${({ theme }) => theme.fontsizes.body14};
    transform: translateY(-3px) /* rtl: none */;
    .rc-rate-star {
      margin-right: 2px;
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
`;

export const RatingNumber = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font500};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body14};
  margin-bottom: 20px;
`;

export const People = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.lightPurple};
  font-size: ${({ theme }) => theme.fontsizes.body12};
  margin-bottom: 10px;
`;
